import MyCartButton from "./MyCartButton.tsx";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { useCartSummary } from "../../homeContext.ts";
import { Suspense } from "react";
import { Await } from "react-router-dom";
import { HeaderTheme } from "./types.ts";

export default function StoreCartButton({ theme }: { theme: HeaderTheme }) {
  const brand = useBrandLoaderData();
  const cartSummary = useCartSummary();

  if (brand.PDP.enabled && !!brand.VirtualStore.companyId) {
    return (
      <Suspense
        fallback={
          <MyCartButton count={0} price={0} to="/my-cart" theme={theme} />
        }
      >
        <Await resolve={cartSummary}>
          {(summary: Awaited<typeof cartSummary>) => (
            <MyCartButton
              theme={theme}
              count={summary.itemCount}
              price={summary.totalPrice}
              currency={summary.currency}
              to="/my-cart"
            />
          )}
        </Await>
      </Suspense>
    );
  }
}
